interface Props {
  className?: string;
}

export const LinkIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <mask
        id="mask0_1364_1574"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="var(--swapper-text-color)" />
      </mask>
      <g mask="url(#mask0_1364_1574)">
        <path
          d="M11 17.5H7C5.61667 17.5 4.4375 17.0125 3.4625 16.0375C2.4875 15.0625 2 13.8833 2 12.5C2 11.1167 2.4875 9.9375 3.4625 8.9625C4.4375 7.9875 5.61667 7.5 7 7.5H11V9.5H7C6.16667 9.5 5.45833 9.79167 4.875 10.375C4.29167 10.9583 4 11.6667 4 12.5C4 13.3333 4.29167 14.0417 4.875 14.625C5.45833 15.2083 6.16667 15.5 7 15.5H11V17.5ZM8 13.5V11.5H16V13.5H8ZM13 17.5V15.5H17C17.8333 15.5 18.5417 15.2083 19.125 14.625C19.7083 14.0417 20 13.3333 20 12.5C20 11.6667 19.7083 10.9583 19.125 10.375C18.5417 9.79167 17.8333 9.5 17 9.5H13V7.5H17C18.3833 7.5 19.5625 7.9875 20.5375 8.9625C21.5125 9.9375 22 11.1167 22 12.5C22 13.8833 21.5125 15.0625 20.5375 16.0375C19.5625 17.0125 18.3833 17.5 17 17.5H13Z"
          fill="var(--swapper-primary-color)"
        />
      </g>
    </svg>
  );
};
